import { getActiveDashboardId } from '../Stores/activeDashboardId'
import type { DashboardLayout } from '../types'

export interface FindDashboardProps {
    dashboards: DashboardLayout[]
    /** Search will prefer `dashId` over `activeDashboardId` */
    dashId?: string
}

/** Given a dashboard list, this finds a specific dashboard by dashId or activeDashboardId */
export const findDashboard = ({ dashboards, dashId }: FindDashboardProps) => {
    if (!dashboards.length) {
        return undefined
    }

    const searchId = dashId || getActiveDashboardId()
    const dashboard = dashboards.find((d) => d.id === searchId)

    return dashboard
}
